import { render, staticRenderFns } from "./DeliveryAnnotation.vue?vue&type=template&id=201c1f25&"
import script from "./DeliveryAnnotation.vue?vue&type=script&lang=js&"
export * from "./DeliveryAnnotation.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryAnnotation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports